export default __webpack_public_path__ + "static/media/affligem_s2.b97f81ad.png";